import { Grid } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { memo } from 'react';
import Text from '../../../../../react-components/Text';

interface MapFiltersItemProps {
  containerStyles?: React.CSSProperties;
  image?: string;
  imageStyles?: React.CSSProperties;
  intlId?: string;
  textStyles?: React.CSSProperties;
  active?: boolean;
  onClick?: () => void;
  empty?: boolean;
}

export const MapFiltersItem = memo(
  ({ containerStyles, image, imageStyles, active, intlId, textStyles, onClick, empty }: MapFiltersItemProps) => {
    return (
      <Grid
        item
        container
        direction="column"
        alignItems="center"
        width="66px"
        height="69px"
        flexWrap={`nowrap`}
        onClick={onClick}
        style={{ cursor: `pointer`, ...containerStyles }}
      >
        {!empty && (
          <>
            <img
              src={image}
              alt=""
              draggable="false"
              style={{
                width: `44px`,
                height: `44px`,
                borderRadius: `5px`,
                border: active ? `2px solid ${RoutalPalette.primary40}` : `1px solid ${RoutalPalette.neutral10}`,
                ...(active ? { padding: `1px` } : { margin: `2px` }),
                ...imageStyles,
              }}
            />

            <Text style={{ marginTop: `6px`, whiteSpace: `nowrap`, ...textStyles }} intlId={intlId} />
          </>
        )}
      </Grid>
    );
  }
);
